import React from "react";
import { useInView } from "../hooks/useInView";

// Wraps any content with a scroll-triggered fade+slide reveal.
// `delay` maps to the .reveal-delay-{1..4} CSS classes (100/200/300/400ms).
const RevealSection = ({ children, delay = 0, className = "", as: Tag = "div", ...rest }) => {
  const { ref, inView } = useInView(0.12);
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? "visible" : ""} ${delay ? `reveal-delay-${delay}` : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default RevealSection;
